<template>
  <div class="hello">
    <img alt="Dr n. med. Agnieszka Timorek-Lemieszczuk" src="../assets/logo.png" class="rounded-lg img-fluid img-thumbnail">
    <h6><span>{{ title }}</span> {{ name }}</h6>
    <h4>Ginekolog</h4>
    <div class="text-left p-4">
        <h5 class="text-underline">Przyjmuje w:</h5>
        <h4 class="tmc"><a href="https://topmedicalclinic-hounslow.co.uk/">Top Medical Clinic</a></h4>
        <address>
            Unit 1 Colmore House,<br>Frazer Nash Close<br>
            <h5 class="pt-2">Isleworth, TW7 5AG</h5>
            <h5 class="pt-3">020 8847 3988</h5>
            <h5 class="pt-3">077 1930 5019</h5>
        </address>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftSidebar',
  data () {
    return {
      title: 'Dr n. med.',
      name: 'Agnieszka Timorek-Lemieszczuk'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h4 {
  color: #00a3b6; 
}
h6 {
  padding-top: 20px;
  font-weight: 400;
  text-align: center;
  & span {
    font-size: 100%;
    word-spacing: -3px;
    color: #00a3b6;
  }
}
.tmc {
  color: #994c9c;
}
.text-underline {
  text-decoration: underline;
}
</style>